import React, { useEffect, useState } from 'react'
import Each from '../../../../../components/Each'
import { useLocation, useNavigate } from 'react-router-dom';
import { GET_DRAFT_FORM_RECIEPIENT, SEND_REQUEST_VERIFICATION, DELETE_DRAFT_FORM_RECIEPIENT } from '../../../../../Utils/constant'
import API from '../../../../../ApiConfig'
import Loader from '../../../../../components/Loader'
import _ from 'lodash'
import { Delay, _ToNormal } from '../../../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import { pencil } from 'react-icons-kit/icomoon/pencil'
import { Icon } from 'react-icons-kit';
import useRefreshToken from '../../../../../Hooks/usegenerateToken';
import RecipientForm from '../../../../../components/Verifier/RecipientForm';
import ErrorBoundary from '../../../../../components/ErrorBoundary';
import SlideUpWrapper from '../../../../../components/Transitions/SlideUpWrapper';
import ShimmerLoader from '../../../../../components/ShimmerLoader'
import Pagination from '../../Pagination';
import BreadCrumb from '../../../../../components/Verifier/breadcrumb/BreadCrumb';
import { BUTTONS, MESSAGE } from '../../../../../Utils/Strings';
import BtnLoader from '../../../../../components/BtnLoader';
import Error from '../../../../../components/OnBoard/Error';
import IssuerNavigator from '../../../../../components/DashBoard/IssuerNavigator';

export default function RecipientsDetails({ id }) {

    const location = useLocation()
    const navigate = useNavigate()
    // useRefreshToken(BASE_URL + USER_TOKEN)

    let form = location.state?.selectedOption || 0

    const [loading, setLoading] = useState(false)
    const [activeItem, setActiveItem] = useState(null)
    const [fieldsData, setFieldsData] = useState([])
    const [list, setList] = useState([])
    const [addmore, setAddmore] = useState(false)
    const [deleting, setDeleting] = useState(null)

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        if (form?.form_uuid)
            getFormFields()
    }, [])

    const getDraftList = (fieldsData) => {
        const makeList = (list) => {
            let oldList = []
            list.map(item => {
                let draftItem = []
                fieldsData.map(field => {
                    let newField = { ...field }
                    newField.recipient_detail_id = item.id
                    newField.value = item[field.field_name]
                    draftItem.push(newField)
                })
                oldList.push(draftItem)
            })
            setList(oldList)
            setActiveItem(null)
            setAddmore(false)
        }
        API.get(GET_DRAFT_FORM_RECIEPIENT + form.form_id, {
            // params: {
            //     page_number: currentPage
            // }
        }).then(res => {
            setLoading(false);
            if (res.data.status === 200) {
                // let { data } = res
                // let { data: { items }, data: { total_pages } } = data
                // setTotalPages(total_pages);
                makeList(res.data.data)
            }
        })
            .catch(err => {
                setLoading(false)
                if ((err.response && err.response.status === 403)) {
                    //cogoToast.error("Something Went Wrong")
                } else {
                    cogoToast.error("Something went wrong while fetching list!")
                }

            })
        // setList(list)
    }

    function getFormFields() {
        const listData = [
            {
                "id": 10,
                "type": "email",
                "is_required": true,
                "placeholder": "email@email.com",
                "field_name": "notification_info_email",
                "label": "Email",
                "isRequired": true,
                "fieldType": 1,
                "value": ""
            },
            {
                "id": 11,
                "type": "string",
                "is_required": true,
                "placeholder": "Markov, Shane123",
                "field_name": "notification_info_name",
                "label": "Name",
                "isRequired": true,
                "fieldType": 1,
                "value": ""
            },
            {
                "id": 12,
                "type": "number",
                "is_required": true,
                "placeholder": "987654321",
                "field_name": "notification_info_phone_number",
                "label": "Phone Number",
                "isRequired": true,
                "fieldType": 1,
                "value": ""
            }
        ]
        setFieldsData(listData)
        // getDraftList(listData)
        // setLoading(true)
        // API.get(GET_DOCUMENT_FORM_FIELDS + doc.id)
        //     .then(res => {
        //         setLoading(false)
        //         if (res.data.status === 200) {
        //             // let listData = [...res.data?.data, ...notificationFields]
        //             let listData = res.data?.data
        //             listData.map(item => {
        //                 item.label = _ToNormal(item.field_name)
        //                 item.isRequired = item.is_required || false
        //                 item.fieldType = 1
        //                 item.value = ''
        //             })
        //             getDraftList(listData)
        //             setFieldsData(listData)
        //         }
        //     })
        //     .catch(err => {
        //         setLoading(false)

        //     })
    }

    const handleAccordian = (index) => {
        if (index === activeItem)
            setActiveItem(null)
        else {
            setActiveItem(index)
            setAddmore(false)
        }
    }

    async function deleteRecipient(id, index) {

        setDeleting(index)
        await Delay()
        API.delete(DELETE_DRAFT_FORM_RECIEPIENT + id)
            .then(res => {
                setDeleting(null)
                cogoToast.success('Removed Successfully!')
                getDraftList(fieldsData, true)
            })
            .catch(err => {
                setDeleting(null)
                cogoToast.error('Something went wrong!')
            })

    }

    // const handleSubmitPrev = () => {
    //     if (list.length > 0) {
    //         handleStep(3);
    //     }
    //     else {
    //         cogoToast.error("Please save your details")
    //     }
    // }

    useEffect(() => {
        setCurrentPage(1);
    }, [])

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    }

    const submitData = () => {
        let APIData = {
            "verifier_id": id, // add verifier ID
            "form_id": form.form_id
        }
        if (list.length > 0) {
            setLoading(true)
            API.post(SEND_REQUEST_VERIFICATION, APIData)
                .then(res => {
                    cogoToast.success('Notification sent to ' + list.length + ' Recipients')
                    navigate('../forms/myRequests')
                })
                .catch(err => {
                    cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
                }).finally(() => setLoading(false))
        }
        else {
            cogoToast.error(MESSAGE.NO_DATA_TO_SAVE)
        }

    }

    if (form == 0) {
        return (
            <Error Message='Invalid Form' />
        )
    }

    const sendRequest = () => {
        return (
            <div style={{ display: 'flex', gap: '1rem', width: '20.7rem' }}>
                <button className='btn' onClick={() => navigate('../forms/selectForms')}>{BUTTONS.CANCEL}
                </button>
                <button className='btn btn-primary' onClick={submitData}>
                    {loading ? <BtnLoader label={BUTTONS.SEND_REQUEST} /> : BUTTONS.SEND_REQUEST}
                </button>
            </div>
        )
    }

    return (
        <>
            <Loader isOpen={loading} />
            <BreadCrumb pos={2} title={"Request Verification"} category={"verification"} />
            <IssuerNavigator
                title={'Add Receipient Details'}
                step={'/dashboard/forms/selectType'}
                actions={()=>{}}
                state={{ form: form }}
            />

            <div className="issuerSearchBar">
                <div className="custom-tr" style={{ alignItems: 'center', gap: '1rem', borderBottom: 'none' }}>
                    Form <input className="issuer-input issuer-input-wrapper" disabled value={form.form_name} />
                </div>
            </div>
            <SlideUpWrapper direction='slide-left'>

                {list.length > 0 ?
                    <div className='custom-table'>
                        <div className='custom-tr'>
                            <div className='custom-th'>Email</div>
                            <div className='custom-th'>Name</div>
                            <div className='custom-th'>Phone Number</div>
                            <div className='custom-th text-c'>Action</div>
                        </div>
                        <Each of={list} render={(item, index) => {
                            return (
                                <div key={index}>
                                    <div className='custom-tr' style={{ animationDelay: `${index * 0.1}s` }} >
                                        {item.map((keyItem, keyIndex) => {
                                            if (keyIndex > 2) return
                                            return keyIndex == 0 ? <div className='custom-td'>{keyItem.value}</div>
                                                : <div className='custom-td'>{keyItem.value}</div>
                                        })}

                                        <div className='custom-td text-c'>
                                            <span style={{ fontSize: 25 }} title='Edit' onClick={e => handleAccordian(index)} >
                                                <Icon icon={pencil} />
                                            </span>
                                            <span className='ml-2' title='Remove' onClick={e => deleting ? {} : deleteRecipient(item[0].recipient_detail_id, index)} >
                                                {deleting == index ?
                                                    <span style={{ display: 'inline-block', verticalAlign: 'text-bottom' }}>
                                                        <ShimmerLoader width='1.5rem' />
                                                    </span> :
                                                    <img loading="lazy" alt="" src="/trash.svg" />
                                                }
                                            </span>
                                        </div>

                                    </div>
                                    <div className={index === activeItem ? 'custom-accordian show' : 'custom-accordian'}>
                                        <ErrorBoundary title="Recipient Form">
                                            <RecipientForm
                                                form={form}
                                                onUpdate={getDraftList}
                                                fields={item}
                                                handleCancel={e => setActiveItem(null)}
                                                isIndex={index} />
                                        </ErrorBoundary>
                                    </div>
                                </div>
                            )
                        }} />

                    </div> : null
                }
                {
                    (list.length === 0 || addmore) && Object.keys(fieldsData).length > 0 && activeItem === null ?
                        <ErrorBoundary title="Recipient Form">
                            <RecipientForm
                                form={form}
                                onUpdate={getDraftList}
                                handleCancel={e => list.length > 0 ? setAddmore(false) : {}}
                                fields={fieldsData}
                                data={null} />
                        </ErrorBoundary> : null
                }
                {
                    list.length > 0 && activeItem === null && !addmore ? <div className='addMore-wrapper'>
                        <hr />
                        <button className='btn btn-success add-more' onClick={e => setAddmore(true)} >+ Add More</button>
                    </div> : null
                }
                <div style={{ marginTop: "1rem", display: 'flex', justifyContent: 'flex-end' }}>
                    <Pagination
                        nPages={totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        onPageChange={handlePageChange}
                        loading={loading}
                    />
                </div>
            </SlideUpWrapper >
        </>
    )
}
